import {
    GET_ALL_ACTIVITIES,
    ADD_ACTIVITY,
    EDIT_ACTIVITY,
    DELETE_ACTIVITY,
    GET_ACTIVITY,
    CLEAR_ACTIVITY,
    GET_ACTIVITIES
} from '../actions/ActivityActions'
import { persistReducer } from 'redux-persist';
import storage from 'localforage';

const persistConfig = {
    key: 'activities',
    storage,
};

const initialState = {
    data: [],
    totalActivities: 0,
    totalPages: 0,
    currentPage: 1,

    latestUpdate: '',
    loading: false,
    error: '',

    activity: null,
    activities: null
}

const ActivityReducer = function (state = initialState, action) {
    switch (action.type) {
        case ADD_ACTIVITY: {
            let tempArray = Object.assign({}, state.allActivities)
            tempArray.rows = [action.payload, ...state.allActivities.rows]
            return {
                ...state,
                allActivities: tempArray,
            }
        }
        case EDIT_ACTIVITY: {
            let tempArray = Object.assign({}, state.allActivities)
            let target = tempArray.rows.findIndex(item => {return item.id == action.payload.id})
            tempArray.rows[target] = action.payload            
            return {
                ...state,
                allActivities: tempArray,
            }
        }
        case DELETE_ACTIVITY: {
            let tempArray = Object.assign({}, state.allActivities)
            let newArray = tempArray.rows.filter(item => {return item.id !== action.payload})
            tempArray.rows = newArray            
            return {
                ...state,
                allActivities: tempArray,
            }
        }
        case GET_ALL_ACTIVITIES: {
            return {
                ...state,
                data: action.payload.activities.activities,
                currentPage: action.payload.activities.currentPage,
                totalActivities: action.payload.activities.totalElements,
                totalPages: action.payload.activities.totalPages,
            }
        }
        case GET_ACTIVITY: {
            return {
                ...state,
                activity: action.payload.activity,
            }
        }
        case CLEAR_ACTIVITY: {
            return {
                ...state,
                activity: '',
            }
        }
        case GET_ACTIVITIES: {
            return {
                ...state,
                activities: action.payload.activities,
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default persistReducer(persistConfig, ActivityReducer);
